import { Stack, Text } from '@mantine/core'
import { useState } from 'react'
import CustomModal from 'src/components/CustomComponents/CustomModal/CustomModal'
import BookWordFiles from 'src/containers/BookUniVini/BookWordFiles'
import ReplaceWordFileDialog from 'src/containers/BookUniVini/ReplaceWordFileDialog'
import { BookData, ChapterData } from 'src/interfaces'

// UD-614: every chapter's English Word file with View, Download and Replace.
// BookWordFilesPanel is the list with its Replace dialog (also shown inside the book form);
// BookWordFilesModal is the panel behind "Word file" on a book row.

interface BookWordFilesPanelProps {
	book: BookData | null
	onRefresh?: () => void | Promise<void>
}

export function BookWordFilesPanel({ book, onRefresh }: BookWordFilesPanelProps) {
	const [replaceChapter, setReplaceChapter] = useState<ChapterData | null>(null)

	return (
		<>
			<BookWordFiles book={book} onReplace={setReplaceChapter} />
			{/* Mounted only while open: it then sits above the panel or the form it was opened from */}
			{replaceChapter && (
				<ReplaceWordFileDialog
					opened
					onClose={() => setReplaceChapter(null)}
					book={book}
					chapter={replaceChapter}
					onReplaced={onRefresh}
				/>
			)}
		</>
	)
}

interface BookWordFilesModalProps extends BookWordFilesPanelProps {
	opened: boolean
	onClose: () => void
}

function BookWordFilesModal({ opened, onClose, book, onRefresh }: BookWordFilesModalProps) {
	return (
		<CustomModal size="xl" opened={opened} onClose={onClose} title="English Word files">
			<Stack spacing={12} sx={{ padding: 20 }}>
				<Stack spacing={2}>
					<Text weight={700}>{book?.title || '-'}</Text>
					<Text size="sm" color="dimmed">
						The Word file uploaded for each chapter. Download gives the original file.
					</Text>
				</Stack>
				<BookWordFilesPanel book={book} onRefresh={onRefresh} />
			</Stack>
		</CustomModal>
	)
}

export default BookWordFilesModal
